// @ts-strict-ignore
import { DateInputBlock, parseTokens } from '@coast/schemas';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { ISOString } from '@shared/scenes/cards/agenda/utils';
import { useCurrentUserId } from '@shared/util/hooks';

export function useDefaultTime(block: DateInputBlock) {
  const { values } = useContext(CardFormContext);
  const currentUserId = useCurrentUserId();
  return useMemo(
    () =>
      parseTokens(block.defaultTime || '{today+9hours}', {
        resolveCurrentUserId: () => currentUserId,
        resolveCard: () => values,
      }),
    [block.defaultTime, currentUserId, values],
  );
}

export function useAsISOString(value: any): ISOString {
  return useMemo((): ISOString => {
    if (!value) {
      return undefined;
    }
    const m = moment(value);
    return m.isValid() ? m.toISOString() : undefined;
  }, [value]);
}
